module.exports = __webpack_public_path__ + "img/mobileFrame.cdd7b0c6.png";